export default "__VITE_ASSET__400ab902__"